<section class="container-fluid py-4">
  <div class="row justify-content-md-center mx-0">
    <form
      *ngIf="form"
      class="change-password-form col-md-7 border-form p-md-5 p-4"
      [formGroup]="form"
      (ngSubmit)="submit()"
    >
      <p class="h1 fw-light" data-test-id="change-password-form-title">
        {{ 'CHANGE_PASSWORD_TEXT' | translate }}
      </p>
      <div class="password-group" data-test-id="wrap-change-form-current-password">
        <app-eye-password
          [form]="form"
          [controlName]="'currentPassword'"
          [dataTestId]="'change-form-current-password'"
          [errorTexting]="texting('change-password-form-current-password-error', oldPasswordErrorText)"
          [placeholder]="'CHANGE_PASSWORD_CURRENT_INPUT_PLACEHOLDER'"
          [inputLabel]="'CHANGE_PASSWORD_LABEL_CURRENT'"
          [invalid]="isPasswordFieldInvalid('currentPassword')"
          [formValid]="isFieldValid('currentPassword')"
          [id]="'current-password'"
          [labelDataTestId]="'change-password-form-current-password-label'"
          [iconDataTestId]="'change-password-form-current-password-icon'"
        >
        </app-eye-password>
      </div>
      <div class="password-group" data-test-id="wrap-change-form-password">
        <app-eye-password
          [form]="form"
          [controlName]="'password'"
          [dataTestId]="'change-form-password'"
          [showValidMark]="true"
          [errorTexting]="texting('change-password-form-new-password-error', 'FIELD_PASSWORD_ERROR')"
          [validTexting]="texting('change-password-form-valid-new-password', 'VALID_LOOKS_GOOD')"
          [instructionTexting]="texting('new-password-instruction', 'FORM_PASSWORD_INPUT_INSTRUCTION')"
          [placeholder]="'CHANGE_PASSWORD_NEW_INPUT_PLACEHOLDER'"
          [inputLabel]="'CHANGE_PASSWORD_LABEL_NEW'"
          [invalid]="isFieldInvalid('password')"
          [formValid]="isFieldValid('password')"
          [id]="'new-password'"
          [labelDataTestId]="'change-password-form-new-password-label'"
          [iconDataTestId]="'change-password-form-new-password-icon'"
        >
        </app-eye-password>
      </div>
      <div class="password-group" data-test-id="wrap-change-confirm-form-password">
        <app-eye-password
          [form]="form"
          [controlName]="'repeatPassword'"
          [dataTestId]="'change-confirm-form-password'"
          [showValidMark]="true"
          [validTexting]="texting('change-password-form-valid-new-password', 'VALID_LOOKS_GOOD')"
          [errorTexting]="texting('change-password-form-repeat-password-error', repeatPasswordTextError)"
          [placeholder]="'CHANGE_PASSWORD_NEW_REPEAT_INPUT_PLACEHOLDER'"
          [inputLabel]="'FORM_REPEAT_PASSWORD_INPUT_PLACEHOLDER'"
          [invalid]="isRepeatPasswordFieldInvalid()"
          [formValid]="isRepeatPasswordFieldValid()"
          [id]="'repeat-password'"
          [labelDataTestId]="'change-password-form-repeat-password-label'"
          [iconDataTestId]="'change-password-form-repeat-password-icon'"
        >
        </app-eye-password>
      </div>
      <div class="mb-3">
        <small class="form-text text-muted"> * - {{ 'REQUIRED_FIELD_HINT' | translate }} </small>
      </div>

      <div class="submit-button">
        <button
          class="btn btn-primary text-white"
          type="submit"
          data-test-id="change-password-form-change-btn"
          appLongOperation
          appDebounceClick
          (debounceClick)="submit()"
          [debounceTime]="DEBOUNCE_TIME"
        >
          {{ 'CHANGE_PASSWORD_TEXT' | translate }}
        </button>
        <button
          class="btn btn-secondary text-white ms-3"
          type="button"
          data-test-id="btn-cancel-change-password"
          (click)="cancel()"
        >
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
    </form>
  </div>
</section>
